import * as React from "react";
import JobType from "../../../../../model/job/JobType";
import BaseFormView, {BaseFormViewState} from "../../../../ui/form/BaseFormView";
import JobTypeForm from "../JobTypeForm";
import JobTypeFormBody from "../JobTypeFormBody";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {JobType} data edited job type data.
	 */
	onSubmit: (data: JobType) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Job type to edit
	 */
	editedJobType: JobType;
}

type IState = BaseFormViewState<JobTypeForm>;

export default class EditJobTypeFormView extends BaseFormView<JobTypeForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: JobTypeForm.createJobTypeForm(props.editedJobType),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<JobTypeFormBody form={this.state.form}
								 onFieldChange={this.onFieldChanged}
								 onFieldCompleted={this.onFieldCompleted}
								 onFocusChange={this.onFocusChange}
								 onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update job type"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}
